import spinner from './SpinnerSingleton';

export default function spinWhenDirective() {
	return {
		restrict: 'A',
		scope: false,
		controller: spinWhenDirectiveCtrl,
	};
}

class spinWhenDirectiveCtrl {
	constructor($element, $attrs, $scope) {
		'ngInject';
		$scope.$watch($attrs.shSpinWhen, shouldSpin => {
			$element[shouldSpin ? 'addClass' : 'removeClass'](spinner.className);
		});
	}
}
